export enum CaseType {
  NewCase = 'NewCase',
  ActiveCase = 'ActiveCase',
}
